import HBPopover, {
    IPopoverProps
} from '@honeybook/hbui/dist/components/HBPopover/HBPopover';
import FlowThumbnail from '~/components/AngularEntries/FlowThumbnail';
import React from 'react';
import { IFlowThumbnail } from '~/types/model.types';
import styled from 'styled-components';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import PendingChangesText from '~/components/common/FlowTemplates/FlowPendingChanges/PendingChangesText';

interface Props {
    thumbnailImage: IFlowThumbnail;
    hasPendingChanges?: boolean;

    popoverProps?: Omit<
        IPopoverProps,
        | 'target'
        | 'children'
        | 'openTrigger'
        | 'keepOpenOnHover'
        | 'shouldSupportOverflowHidden'
        | 'customStyle'
    >;

    flowTitle: string;
    isLeadForm?: boolean;
    isInactive?: boolean;
}

const FlowThumbnailWithPopover = ({
    thumbnailImage,
    hasPendingChanges,
    popoverProps,
    flowTitle,
    isInactive,
    isLeadForm
}: Props) => {
    return (
        <HBPopover
            target={
                <ThumbnailContainer>
                    <FlowThumbnail
                        thumbnailImage={thumbnailImage}
                        defaultIconSize={16}
                        hasPendingChanges={hasPendingChanges}
                        isInactive={isInactive}
                        isLeadForm={isLeadForm}
                    />
                </ThumbnailContainer>
            }
            testIdName="flow-thumbnail"
            openTrigger="hover"
            keepOpenOnHover={false}
            shouldSupportOverflowHidden
            customStyle={{
                padding: '12px'
            }}
            {...popoverProps}
        >
            <LargeThumbnailContainer>
                <FlowThumbnail
                    thumbnailImage={thumbnailImage}
                    defaultIconSize={16}
                />
            </LargeThumbnailContainer>
            <PreviewTitle type="caption12" color="textPrimary">
                {flowTitle}
            </PreviewTitle>
            {hasPendingChanges && (
                <PendingChangesText
                    isLeadForm={isLeadForm}
                    isDeactivated={isInactive}
                />
            )}
        </HBPopover>
    );
};

export default FlowThumbnailWithPopover;

// -------------------------------- Styles -------------------------------- //
const ThumbnailContainer = styled.div`
    width: 48px;
    height: 32px;
`;

const thumbnailContainerWidth = 220;
const LargeThumbnailContainer = styled.div`
    width: ${thumbnailContainerWidth}px;
    height: 145px;
    margin-bottom: 12px;
`;

const PreviewTitle = styled(HBText)`
    width: ${thumbnailContainerWidth}px;
    display: block;
    overflow-wrap: break-word;
    word-break: break-word;
`;
